import { ViewPerson } from "@/rd/ResearchDataModel"
import { PotentialMember } from "./FamilyGroupMemberManager"
import { isDefined } from "@/util/TypeScriptUtil"

export class ListPerson {
    viewPerson?: ViewPerson

    potentialMembers: ReadonlyArray<PotentialMember> = []


    get id() { return this.potentialMembers.length == 1 ? this.potentialMembers[0].id : this.viewPerson!.id! }

    get isEmpty() { return this.potentialMembers.length == 0 }

    get displayName() { return this.potentialMembers.length == 1 ? this.potentialMembers[0].displayName : this.viewPerson!.displayName }

    get isSuggested() { return this.potentialMembers.every(pm => pm.isSuggested) }

    static fromPotentialMember(pm: PotentialMember) {
        const listPerson = new ListPerson()
        listPerson.potentialMembers = [pm]
        return listPerson
    }

    static fromViewPerson(vp: ViewPerson, potentialMembers: Map<string, PotentialMember>) {
        if (potentialMembers.size > 1 && !vp)
            throw new Error("ListPerson must have a view person when multiple potential members are specified")

        const listPerson = new ListPerson()
        listPerson.viewPerson = vp
        listPerson.potentialMembers = vp.matchIds.map(id => potentialMembers.get(id)).filter(isDefined)
        return listPerson
    }
}
